import { render, staticRenderFns } from "./GalleryGrey.vue?vue&type=template&id=a4b07364&"
import script from "./GalleryGrey.vue?vue&type=script&lang=js&"
export * from "./GalleryGrey.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports